import BaseComponent from '../../../base/base_component';
import {ELEMENTS} from '../navbar_const';
import {USER_EVENTS} from '../../../events/events';
import {ANALYTICS} from '../navbar_const';
import _ from '../../../utils/underscore';

let fullScreenButtonHtml = require('../view/fullscreen-button.html');

export default class FullScreenButtonNavbarPart extends BaseComponent {
    static CLASS = 'FullScreenButtonNavbarPart';


    init(params) {
        super.init(params);
        this._analyticsTrigger = params.analyticsTrigger;

        this.setInnerHtml(fullScreenButtonHtml);

        this.onChildElementEvent(ELEMENTS.FS_BUTTON, USER_EVENTS.ON_CLICK, () => {
            this._analyticsTrigger.send(ANALYTICS.ACTION.FS);
            _.toggleFullScreen();
        });
    }

    exitFullScreen() {
        if (_.isFullScreen()) {
            _.closeFullScreen();
        }
    }
}